export const canUndoReviseProduct = () => () => {
    return function (node) {
        if (! this.permission.has('write')) {
            this.logger.error('没有权限', [node])
            return false
        }

        const {bizNodeType, pkid, stsCode} = node.data

        if (! pkid) {
            this.logger.error('只有制品才能撤销修订', [node])
            return false
        }

        if (! /^(REVISE)$/.test(stsCode)) {
            this.logger.error('只有修订状态的制品才能撤销修订', [node])
            return false
        }

        const bn = this.BizNode[bizNodeType]

        if (! bn.publish) {
            const name = bn.typeName(this, node.parent)
            this.logger.error(`${name}不支持撤销修订`, [node])
            return false
        }

        return (
            ! node.parent ||
            bn.isMounted(this, node)
        )
    }
}

export const undoReviseProduct = () => {
    return () => async function (nodes) {
        const results = await Promise.allSettled(
            [...nodes].map(
                async node => {
                    try {
                        const _n = this.nodeProxy(node)
                        await _n.undoRevise()
                        this.logger.info('撤销修订模型制品成功', [node])
                    }
                    catch (err) {
                        this.logger.error(
                            `撤销修订模型制品失败: ${err.message}`,
                            [node]
                        )

                        err.nodes = [node]
                        throw err
                    }
                }
            )
        )

        const isOk = results.some(e => 'rejected' !== e.status)

        if (isOk) {
            this.resetChangeHistory()
        }

        return results
    }
}
